module.exports = __webpack_public_path__ + "img/case-health-check.1d5f1f91.png";